"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.importAccountsReduce = exports.importAccountsMakeItems = void 0;
var logs_1 = require("@ledgerhq/logs");
var cross_1 = require("../cross");
var support_1 = require("./support");
var joinSwapHistories_1 = __importDefault(require("../exchange/swap/joinSwapHistories"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var itemModeDisplaySort = {
    create: 1,
    update: 2,
    id: 3,
    unsupported: 4
};
var importAccountsMakeItems = function (_a) {
    var result = _a.result, accounts = _a.accounts, items = _a.items;
    return result.accounts
        .map(function (accInput) {
        var prevItem = (items || []).find(function (item) { return item.account.id === accInput.id; });
        if (prevItem)
            return prevItem;
        try {
            var account_1 = (0, cross_1.accountDataToAccount)(accInput);
            var error = (0, support_1.checkAccountSupported)(account_1);
            if (error) {
                return {
                    initialAccountId: account_1.id,
                    account: account_1,
                    mode: "unsupported"
                };
            }
            var migratableAccount = accounts.find(function (a) {
                return (0, support_1.findAccountMigration)(a, [account_1]);
            });
            if (migratableAccount) {
                // in migration case, we completely replace the older account
                return {
                    initialAccountId: migratableAccount.id,
                    account: account_1,
                    mode: "update"
                };
            }
            var existingAccount = accounts.find(function (a) { return a.id === accInput.id; });
            if (existingAccount) {
                // only the name is supposed to change. rest is never changing
                if (existingAccount.name === accInput.name &&
                    (0, isEqual_1["default"])(existingAccount.swapHistory, account_1.swapHistory)) {
                    return {
                        initialAccountId: existingAccount.id,
                        account: existingAccount,
                        mode: "id"
                    };
                }
                return {
                    initialAccountId: existingAccount.id,
                    account: __assign(__assign({}, existingAccount), { name: accInput.name, swapHistory: (0, joinSwapHistories_1["default"])(existingAccount.swapHistory, account_1.swapHistory) }),
                    mode: "update"
                };
            }
            return {
                initialAccountId: account_1.id,
                account: account_1,
                mode: "create"
            };
        }
        catch (e) {
            (0, logs_1.log)("error", String(e));
            return null;
        }
    })
        .filter(Boolean)
        .sort(function (a, b) {
        return itemModeDisplaySort[a.mode] -
            itemModeDisplaySort[b.mode];
    });
};
exports.importAccountsMakeItems = importAccountsMakeItems;
var importAccountsReduce = function (existingAccounts, _a) {
    var e_1, _b;
    var items = _a.items, selectedAccounts = _a.selectedAccounts;
    var accounts = existingAccounts.slice(0);
    var selectedItems = items.filter(function (item) {
        return selectedAccounts.includes(item.account.id);
    });
    var _loop_1 = function (mode, account, initialAccountId) {
        switch (mode) {
            case "create":
                accounts.push(account);
                break;
            case "update": {
                var item = accounts.find(function (a) { return a.id === initialAccountId; });
                var i = accounts.indexOf(item);
                accounts[i] = account;
                break;
            }
            default:
        }
    };
    try {
        for (var selectedItems_1 = __values(selectedItems), selectedItems_1_1 = selectedItems_1.next(); !selectedItems_1_1.done; selectedItems_1_1 = selectedItems_1.next()) {
            var _c = selectedItems_1_1.value, mode = _c.mode, account = _c.account, initialAccountId = _c.initialAccountId;
            _loop_1(mode, account, initialAccountId);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (selectedItems_1_1 && !selectedItems_1_1.done && (_b = selectedItems_1["return"])) _b.call(selectedItems_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return accounts;
};
exports.importAccountsReduce = importAccountsReduce;
//# sourceMappingURL=importAccounts.js.map